import { Box } from "@mui/material";
import BreakdownBars from "../components/BreakdownBars";
import Card, { CardGrid } from "../components/Card";
import KpiTile from "../components/KpiTile";
import SeriesChart from "../components/SeriesChart";
import StatTable from "../components/StatTable";
import StatsGate from "../components/StatsGate";
import { formatDuration, formatNumber, formatPercent } from "../format";
import { TabProps, WatchParties } from "../types";
import { useStats } from "../useStats";

export default function WatchPartiesTab({ query, reloadKey }: TabProps) {
  const state = useStats<WatchParties>("/watch-parties", query, reloadKey);
  return (
    <StatsGate state={state}>
      {(data, envelope) => (
        <>
          <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "repeat(4, 1fr)" }, mb: 2 }}>
            <KpiTile label="Parties open now" value={data.activeNow} />
            <KpiTile label="Average members" value={data.avgMembers} format={formatNumber} />
            <KpiTile label="Join requests approved" value={data.joinRequests.approvalRate} format={formatPercent} />
            <KpiTile label="Hosts with 2+ parties" value={data.repeatHosts} />
            <KpiTile label="Invites created" value={data.invites.created} />
            <KpiTile label="Invites revoked" value={data.invites.revoked} />
            <KpiTile label="Median length (approx.)" value={data.duration.medianSeconds} format={formatDuration} />
            <KpiTile label="90th percentile length (approx.)" value={data.duration.p90Seconds} format={formatDuration} />
          </Box>
          <CardGrid>
            <Card title="Parties created" wide>
              <SeriesChart points={data.series} bucket={envelope.filters.bucket ?? "day"} lines={[{ key: "created", label: "Parties" }]} />
            </Card>
            <Card title="Party size (members ever joined)"><BreakdownBars rows={data.sizeDistribution} /></Card>
            <Card title="Visibility"><BreakdownBars rows={data.byVisibility} /></Card>
            <Card title="Who controls playback"><BreakdownBars rows={data.bySyncControl} /></Card>
            <Card title="Status"><BreakdownBars rows={data.byStatus} /></Card>
            <Card title="Join requests"><BreakdownBars rows={data.joinRequests.byStatus} /></Card>
            <Card title="Top hosts" wide>
              <StatTable
                rows={data.topHosts} getRowId={(r) => r.userId}
                columns={[
                  { field: "displayName", headerName: "Host", flex: 2 },
                  { field: "tenant", headerName: "Tenant", flex: 1 },
                  { field: "parties", headerName: "Parties", type: "number", flex: 1 },
                ]}
              />
            </Card>
          </CardGrid>
        </>
      )}
    </StatsGate>
  );
}
